import React from "react";
import DotsDisplay from "./DotsDisplay";
import { format } from "date-fns";
import { Tooltip } from "@mui/material";
import { ExerciseForHourlySchedule } from "../../../models/ExerciseForHourlySchedule";

interface IProps {
  data: { [name: string]: ExerciseForHourlySchedule[] };
  getPercentageFree: (capacity: number, reserved: number) => number;
}

const HourlyScheduleDesktopTable: React.FC<IProps> = ({ data, getPercentageFree }) => {
  return (
    <table className="hourly-schedule-table">
      <tbody>
        {Object.keys(data).map((item, index) => (
          <tr key={index}>
            <td className="bold">{item}</td>
            {Object.values(data[item]).map((itemValue, itemIndex) => (
              <td key={itemIndex}>
                <Tooltip
                  title={
                    <span className="hourly-schedule-table-tooltip">
                      Wolne miejsca: {itemValue.capacity - itemValue.reserved} z {itemValue.capacity}
                    </span>
                  }
                >
                  <div className={`hourly-schedule-table-item`}>
                    {format(itemValue.startTime, "HH:mm")}
                    <DotsDisplay percentageFree={getPercentageFree(itemValue.capacity, itemValue.reserved)} />
                  </div>
                </Tooltip>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HourlyScheduleDesktopTable;
